import { FC, useContext, useMemo } from 'react'
import { useQuery } from 'react-query'
import {
  createResponseContext,
  initialQueryResponse,
  QUERIES,
  stringifyRequestQuery,
  WithChildren,
} from '../../../../../../_metronic/helpers'
import { useQueryRequest } from './QueryRequestProvider'
import { EmpresaList } from '../../../empresa/empresas-list/core/_models'
import { getEmpresas } from '../../../empresa/empresas-list/core/_requests'
import { useModal } from '../../../../../components'

const QueryResponseContext = createResponseContext<EmpresaList>(initialQueryResponse)
export const QueryResponseProvider: FC<WithChildren> = ({ children }) => {
  const { isOpen } = useModal()
  const { state } = useQueryRequest()

  const query = useMemo(() => stringifyRequestQuery(state), [state])

  // Chave própria: a listagem de Instituição usa EMPRESAS_LIST com o mesmo endpoint.
  const {
    isFetching,
    isError,
    refetch,
    data: response,
  } = useQuery([QUERIES.API_EMPRESAS_LIST, query, isOpen], () => getEmpresas(query), {
    cacheTime: 0,
    keepPreviousData: true,
    refetchOnWindowFocus: false,
    enabled: !isOpen,
  })

  return (
    <QueryResponseContext.Provider
      value={{ isLoading: isFetching, isError, refetch, response, query }}
    >
      {children}
    </QueryResponseContext.Provider>
  )
}

export const useQueryResponse = () => useContext(QueryResponseContext)
